import { Button } from "@patient-watch/ui/button";
import { ConsentSigningSection } from "@/features/consent/components/ConsentSigningSection";
import { consentKeys, fetchConsentById, resolveConsentReadLocale } from "@/features/consent/api/selectConsentById";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/preview/consent/$consentId")({
    component: ConsentPreviewPage,
    loader: async ({ context: { queryClient }, params }) => {
        const locale = resolveConsentReadLocale();
        const consent = await queryClient.ensureQueryData({
            queryKey: consentKeys.byId(params.consentId, locale),
            queryFn: () => fetchConsentById(params.consentId, locale),
        });

        return { consentId: params.consentId, diaryId: consent?.diary_id ?? null };
    },
});

function ConsentPreviewPage() {
    const { consentId } = Route.useParams();
    const { diaryId } = Route.useLoaderData();

    if (!diaryId) {
        return (
            <div className="flex flex-col justify-center items-center p-4 min-h-[40vh]">
                <h1 className="mb-4 font-bold text-2xl">Consent Not Found</h1>
                <p className="mb-6 text-muted-foreground">The consent form you are looking for could not be found.</p>
                <Button variant="outline" onClick={() => window.history.back()}>
                    Go Back
                </Button>
            </div>
        );
    }

    return <ConsentSigningSection consentId={consentId} diaryId={diaryId} readOnly />;
}
